import React from 'react';

import { InventoryProvider } from './InventoryContext';
import { BundleSettingProvider } from './BundleSettingContext';
import { CustomerAddressProvider } from './CustomerAddressContext';

const composeProviders = (...providers) => ({ children }) => {
  return providers.reduceRight(
    (child, Provider) => <Provider>{child}</Provider>,
    children,
  );
};

const Providers = composeProviders(
  InventoryProvider,
  BundleSettingProvider,
  CustomerAddressProvider,
);

const Provider = ({ children }) => <Providers>{children}</Providers>;

export default Provider;
